import { useTranslation } from 'react-i18next';

import { licensesList } from './LicensesList';
import { OrderedListStyled } from './ThirdPartyLicensesStyled';

export const ThirdPartyLicenses = () => {
  const { t } = useTranslation('pages.thirdPartyLicenses');

  return (
    <div data-testid="third-party-licenses-page">
      <p>{t('description')}</p>
      <OrderedListStyled>
        {licensesList.map((item, index) => {
          return (
            <div key={index}>
              <li>
                <b>{item.name}</b>
              </li>
              <ul>
                <li>{`${t('authorLabel')}: ${item.author}`}</li>
                <li>{`${t('versionLabel')}: ${item.version}`}</li>
                <li>{`${t('licenseLabel')}: ${item.license}`}</li>
              </ul>
            </div>
          );
        })}
      </OrderedListStyled>
    </div>
  );
};
